module.exports = __webpack_public_path__ + "images/emoji/trolleybus.db5d1fa08a0e1afd7ae0.png";